export function layout($, lightGallery) {

  // Navigation effects
  $('#mainnav').prepend('<span id="hoverline" style="display: none"></span>')

  $('#mainnav li').hover(function() {
    var width = $(this).width();
    var left = $(this).position().left;
    var toTop = ($(this).position().top + $(this).height());

    if ($(this).hasClass('current-menu-item')) {
      
      $('#hoverline').css({
        'width': width,
        'left': left,
        'top': toTop
      }).removeClass('linkable').show();
    } else {
      $('#hoverline').css({
        'width': width,
        'left': left,
        'top': toTop
      }).addClass('linkable').show();
    }

  });
  $('#mainnav').mouseleave(function() {
    $('#hoverline').hide();
  });


  // Lightbox
	$('.figure-lightbox-wrapper').lightGallery({
    thumbnail:false,
    animateThumb: false,
    showThumbByDefault: false,
    selector: '.figure-lightbox'
	});

}
